'use strict'

import HomeView from '@/views/HomeView.vue'

export default [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView,
    meta: {
      title: null
    }
  },
  {
    path: '/events',
    name: 'EventsView',
    component: () => import( /* webpackChunkName: "EventsView" */ '@/views/EventsView.vue'),
    meta: {
      title: 'Events/Car Shows'
    }
  },
  {
    path: '/contact',
    name: 'ContactView',
    component: () => import( /* webpackChunkName: "ContactView" */ '@/views/ContactView.vue'),
    meta: {
      title: 'Contact Us'
    }
  },
  {
    path: '/legal/privacy',
    name: 'PrivacyPolicyView',
    component: () => import( /* webpackChunkName: "PrivacyPolicyView" */ '@/views/PrivacyPolicyView.vue'),
    meta: {
      title: 'Privacy Policy'
    }
  },
  // {
  //   path: '/register/:id',
  //   name: 'RegisterView',
  //   component: () => import( /* webpackChunkName: "RegisterView" */ '@/views/RegisterView.vue'),
  //   meta: {
  //     title: 'Register Online'
  //   }
  // },
  {
    path: '/covid',
    name: 'CovidView',
    component: () => import( /* webpackChunkName: "CovidView" */ '@/views/CovidView.vue'),
    meta: {
      title: 'COVID-19'
    }
  },
  {
    path: '*',
    name: 'NotFoundView',
    component: () => import( /* webpackChunkName: "NotFoundView" */ '@/views/NotFoundView.vue'),
    meta: {
      title: 'Oops!'
    }
  }
]